module.exports = __webpack_public_path__ + "static/img/07063D_1_2_C_20210531_fit.929c746.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/07063D_1_2_C_20210531_fit.png
// module id = hD0l
// module chunks = 0